const getters = {
    getSetoranKasOutletList: (state) => state.setoranKasOutletList,
    getSetoranKasOutletDetail: (state) => state.setoranKasOutletDetail,
    getPagination: (state) => state.pagination,
    getSearch: (state) => state.search,
    getIsSearch: (state) => state.isSearch,
    getQuerySetoranOutletList: (state) => state.querySetoranOutletList,
    getScrollPosition: (state) => state.scrollPosition,
};

export default getters;
